import React              from 'react';
import PropTypes          from 'prop-types';
import {Viewer}           from './Viewer';
import {VideoPlayer}      from './VideoPlayer';
import GlobalEventHandler from './../../utils/GlobalEventHandler';
import Translations       from './../../utils/Translations';
import Flux               from './../../flux/Flux';

class Gallery extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			actor:                {},
			images:               this.props.initialImages,
			isModelGuestFavorite: this.props.isModelGuestFavorite,
			selectedIndex:        0,
			videos:               this.props.initialVideos,
		};

		this.onGalleryChange    = this.onGalleryChange.bind(this);
		this.onGalleryMove      = this.onGalleryMove.bind(this);
		this.onViewerChange     = this.onViewerChange.bind(this);
		this.select             = this.select.bind(this);
		this.shouldLoadSedcards = this.shouldLoadSedcards.bind(this);
		this.hasData            = this.hasData.bind(this);
	}

	componentDidMount() {
		GlobalEventHandler.addListener(GlobalEventHandler.GALLERY_MOVE, this.onGalleryMove);

		// no data, load sedcards for actor?
		if (this.shouldLoadSedcards()) {
			Flux.Gallery.addGalleryChangeListener(this.onGalleryChange);

			Flux.Gallery.loadSedcards(this.props.actorId);
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.isModelGuestFavorite !== this.props.isModelGuestFavorite) {
			this.setState({
				isModelGuestFavorite: nextProps.isModelGuestFavorite,
			});
		}

		if (nextProps.initialVideos !== this.props.initialVideos) {
			this.setState({
				videos: nextProps.initialVideos,
			});
		}
	}

	componentWillUnmount() {
		Flux.Gallery.removeGalleryChangeListener(this.onGalleryChange);

		GlobalEventHandler.removeListener(GlobalEventHandler.GALLERY_MOVE, this.onGalleryMove);
	}

	onGalleryChange() {
		const album = Flux.Gallery.getSedcards(this.props.actorId);

		if (album) {
			this.setState({
				isModelGuestFavorite: album.isModelGuestFavorite,
				actor:                album.actor,
				title:                album.title,
				images:               album.photos,
			});
			if(Object.keys(this.props.sedcard).length === 0){
				this.props.setSedcard(album);
			}
		}
	}

	onGalleryMove(instanceId, offset) {
		if (this.props.instanceId === instanceId) {
			const newIndex = (this.state.selectedIndex + offset) % this.state.images.length;
			this.select(newIndex >= 0 ? newIndex : this.state.images.length + newIndex);
		}
	}

	select(index) {
		const selectedIndex = Math.min(this.state.images.length - 1, Math.max(0, index));
		GlobalEventHandler.emit(GlobalEventHandler.GALLERY_SELECT, this.props.instanceId, selectedIndex);

		this.setState({
			selectedIndex: selectedIndex,
		});
	}

	onViewerChange(selectedIndex) {
		this.setState({
			selectedIndex: selectedIndex,
		});
	}

	shouldLoadSedcards() {
		return (!this.props.initialImages || this.props.initialImages.length <= 0) && this.props.actorId && (!this.props.initialVideos || this.props.initialVideos.length <= 0);
	}

	hasData() {
		return (this.state.images && this.state.images.length > 0) || (this.state.videos && this.state.videos.length);
	}

	render() {
		if (!this.hasData()) {
			return false;
		}

		const tilesToShow        = 4;
		const viewStartTileIndex = Math.floor(this.state.selectedIndex / tilesToShow) * tilesToShow;

		const tilesDom = [];
		for (let i = 0; i < tilesToShow; ++i) {
			const currIndex = viewStartTileIndex + i;
			const item      = this.state.images[currIndex];
			const onClick   = () => {
				this.select(currIndex);
			};

			if (item) {
				tilesDom.push(
					<div className={'gallery__tile h-cursor-pointer ' + (currIndex === this.state.selectedIndex ? 'is-active' : '')}
					     onClick={onClick}
					>
						<i className="gallery__tile__icon icon -icon-image-line" />
						<img className="h-disp-block" src={item.previewUrl} />
					</div>);
			} else {
				tilesDom.push(<div className={'gallery__tile'}>&nbsp;</div>);
			}
		}

		return (
			<div className="clearfix h-height-full">
				{this.state.images && this.state.images.length > 0 &&
				<Viewer initialImages={this.state.images}
				        instanceId={this.props.instanceId}
				        title={this.state.title}
				        actor={this.state.actor}
				        initialIsFavoriteOfGuest={this.state.isModelGuestFavorite}
				        selectedIndex={this.state.selectedIndex}
				        onShowModal={this.props.onShowModal}
				        onChange={this.onViewerChange}
				        hideAlbumInfo={this.props.hideAlbumInfo}
				        hideVoting={this.props.hideVoting}
				/>}
				{this.state.videos && this.state.videos.length > 0 &&
				<VideoPlayer initialVideos={this.state.videos}
				             videoBadgesConfig={this.props.videoBadgesConfig}
				             instanceId={this.props.instanceId}
				             selectedIndex={this.state.selectedIndex}
				             onShowModal={this.props.onShowModal}
				             onChange={this.onViewerChange}
				             onEnded={this.props.onEnded}
				             onFullScreenEnter={this.props.onFullScreenEnter}
				             onFullScreenExit={this.props.onFullScreenExit}
				             onPlay={this.props.onPlay}
				             enablePreviewButton={this.props.enablePreviewButton}
				             loadIncentiveOnEmptyVideo={this.props.loadIncentiveOnEmptyVideo}
				             videoTimestamp={this.props.videoTimestamp}
				             showDownload={this.props.showDownload}
				             outerContainerClass='h-height-full'
				             isHD={this.props.isHD}
				             showLike={!!this.state.videos[0]?.isVotingVisible}
				             showDislike={!!this.state.videos[0]?.isVotingVisible}
				             showCinematicMode={this.props.showCinematicMode}
				             actorId={this.props.actorId}
				             vxbuttonAdditionalStyle={this.props.vxbuttonAdditionalStyle}
							 onFirstPlay={this.props.onFirstPlay}
                             triggerPauseVideoEvent={this.props.triggerPauseVideoEvent}
                             onBuy={this.props.onBuy}
				/>}
				{this.props.showTiles && <div className="gallery__tiles h-clear">
					{tilesDom}
					<a href="#" className="gallery__tile -c2a">
						<span dangerouslySetInnerHTML={{__html: Translations.get('ActorProfileShowAll')}} />
					</a>
				</div>}
			</div>
		);
	}
}

Gallery.propTypes = {
	actorId:                       PropTypes.number,
	enablePreviewButton:           PropTypes.bool,
	hideAlbumInfo:                 PropTypes.bool,
	hideVoting:                    PropTypes.bool,
	initialImages:                 PropTypes.array,
	initialVideos:                 PropTypes.array,
	instanceId:                    PropTypes.string,
	isModelGuestFavorite:          PropTypes.bool,
	loadIncentiveOnEmptyVideo:     PropTypes.bool,
	onEnded:                       PropTypes.func,
	onFullScreenEnter:             PropTypes.func,
	onFullScreenExit:              PropTypes.func,
	onPlay:                        PropTypes.func,
	onShowModal:                   PropTypes.func,
	showTiles:                     PropTypes.bool,
	videoTimestamp:                PropTypes.number,
	sedcard:                       PropTypes.object,
	setSedcard:					   PropTypes.func,
	showDownload:                  PropTypes.bool,
	videoBadgesConfig:             PropTypes.shape({
		album:             PropTypes.object,
		isGift:            PropTypes.bool,
		isOver18Content:   PropTypes.bool,
		isNew:             PropTypes.bool,
		getPrice:          PropTypes.number,
		needBuying:        PropTypes.bool,
		hasActiveDiscount: PropTypes.bool,
		isContestContent:  PropTypes.bool,
		getDiscountBadge:  PropTypes.string,
		currency:          PropTypes.string,
	}),
	isHD:                          PropTypes.bool,
	showCinematicMode:             PropTypes.bool,
	vxbuttonAdditionalStyle:       PropTypes.object,
	onFirstPlay:                   PropTypes.func,
    triggerPauseVideoEvent:        PropTypes.bool,
    onBuy:                         PropTypes.func
};

Gallery.defaultProps = {
	hideAlbumInfo:                 false,
	hideVoting:                    false,
	initialImages:                 [],
	initialVideos:                 [],
	instanceId:                    'gallery',
	loadIncentiveOnEmptyVideo:     false,
	setSedcard:					   () => {},
	showTiles:                     false,
	videoTimestamp:                0,
	showDownload:                  true,
	videoBadgesConfig:             {
		album:             {},
		isGift:            false,
		isOver18Content:   false,
		isNew:             false,
		getPrice:          0,
		needBuying:        false,
		hasActiveDiscount: false,
		isContestContent:  false,
		getDiscountBadge:  '',
		currency:          '',
	},
	isHD:                          false,
	showCinematicMode:             false,
	onFirstPlay:                   null,
    triggerPauseVideoEvent:        false,
    onBuy:                         null
};

export default Gallery;
